var _circle, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 40 40",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "#2563eb"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(8, 8)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 2,
    width: 14,
    height: 20,
    rx: 2.5,
    fill: "white",
    opacity: 0.95
  }), /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 4,
    width: 10,
    height: 14,
    rx: 1,
    fill: "#2563eb"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 20,
    r: 1.2,
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(9, 6) rotate(-30, 5, 5)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 0,
    width: 2,
    height: 8,
    rx: 1,
    fill: "white",
    opacity: 0.9
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 0,
    width: 6,
    height: 2.5,
    rx: 1,
    fill: "white",
    opacity: 0.9
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 6,
    width: 6,
    height: 2.5,
    rx: 1,
    fill: "white",
    opacity: 0.9
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.cf0fcd0eaff26f2b17745ff1df31f92b.svg";
export { ForwardRef as ReactComponent };